import { DataGrid } from '@mui/x-data-grid'
import { getArvColumns } from './columns'

export default function ComparableGrid({ rows, onRowClick, onToggleArchived, onGalleryOpen }) {
  const columns = getArvColumns({ onRowClick, onToggleArchived, onGalleryOpen })

  return (
    <div className=" rounded-lg overflow-hidden">
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={(row) => row.propertyId}
      rowHeight={72}
      autoHeight
      hideFooter
      disableRowSelectionOnClick
      sx={{
        border: 'none',
        fontFamily: 'Figtree',
        overflow: 'hidden',
        '--DataGrid-rowBorderColor': '#DAE4D5',
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#E7F0E2',
          borderBottom: 'none',
          minHeight: '52px !important',
          maxHeight: '52px !important',
          padding:'0 0'
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          padding:'0 0',
          fontSize: 14,
          fontWeight: 700,
          color: '#17270D',
        },
        '& .MuiDataGrid-cell': {
          display: 'flex',
          alignItems: 'center',
          padding: '0 0',
        },
        // Comment Set #1, ARV 7.4: #F7F9F6, "apply to Pipeline table as well". The colour is drawn
        // too — grid-btn-states/Frame 308_4 — so this is the design's hover, not only his number.
        // #E8F5E1 stood here before and is the SELECTED fill on the Pipeline grid; a hover that
        // matched a selection was saying two different things with one colour.
        '& .MuiDataGrid-row:hover': {
          backgroundColor: '#F7F9F6',
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
          padding: '0 !important', 
        }
      }}
    />
    </div>
  )
}
